module.exports = __webpack_public_path__ + "img/Barre_Actions_MercuComparative.ed871708.png";